<template>
  <div>
    <Bedienfeld
      :task-class="taskClass"
      :template-query="templateQuery"
      ref="tag"
      @viewTypeChange="onViewTypeChange"
    >
      <el-row>
        <el-col
          :span="12"
          style="text-align: center;"
        />
        <el-col :span="12">
          <div style="width:95%;" />
        </el-col>
      </el-row>
    </Bedienfeld>
    <div>
      <el-container class="taskList">
        <el-main>
          <GroupList
            :is-show-button="false"
            :template-query="templateQuery"
            :is-group="isGroup"
            :table-height="tableHeight"
            ref="taskTable"
            @changeCurTask="changeCurTask"
          />
        </el-main>
        <el-aside
          width="250px"
          v-show="expand==false?taskDetailShow:true"
          class="attbg"
          style="box-sizing: border-box;position: relative;padding-top: 10px;"
        >
          <selectSuspension
            v-show="expand"
            ref="Suspension"
            :table-height="tableHeight"
            @detailsEvent="DetailsEvent"
            @getValue="getValue"
          />
        </el-aside>
      </el-container>
      <!-- <div class="suspension" v-show="type != 3">
        <el-button
          type="primary"
          @click="operationPanel"
          :icon="expand?'el-icon-d-arrow-right':'el-icon-d-arrow-left'"
          circle
        ></el-button>
      </div>-->
    </div>
    <el-row>
      <el-col :span="24">
        <div style="background: white;margin-top: 10px;">
          <task-tag :tag-list="searchCondition" />
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import Bedienfeld from "./Bedienfeld.vue";
import taskTag from "@/views/task/common/tag.vue";
import selectSuspension from "@/components/MainLayout/template/selectSuspension.vue";
import GroupList from "@/views/task/taskFolderView/TaskGroup.vue";
import searchJs from "@/util/search";
import { GetTaskListByTaskIdList } from "@/api/modules/basicData/task";
import { mapState } from "vuex";
export default {
  name: "TaskList",
  components: {
    Bedienfeld,
    selectSuspension,
    GroupList,
    taskTag //搜索条件标签页
  },
  props: {
    templateQuery: Object,
    tableHeight: {
      type: [Number,String],
      default: function() {
        return ($(window).height() - 250);
      }
    },
    isGroup: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      expand: true,
      taskClass: "",
      type: this.$route.query.type || 2,
      viewType: "list",
      selectRadioState: "",
      selectCheckboxState: [],
      StateName: "执行状态",
      setWidth: "100%",
      listHeight: "",
      stateData: [
        {
          value: "0",
          name: "待接收"
        },
        {
          value: "1",
          name: "执行中"
        },
        {
          value: "4",
          name: "审批中"
        },
        {
          value: "2",
          name: "已完成"
        }
      ],
      curTask: {} //任务选择值
    };
  },
  computed: {
    ...mapState({
      taskSource: state => state.task.taskSource,
      userId: state => state.task.userId,
      searchCondition: state => state.task.searchCondition
    }),
    Query() {
      this.selectRadioState = "";
      if (!this.templateQuery) return { Alone: {} };
      if (this.templateQuery.TEMPTYPE != 1) {
        if (this.templateQuery.CONTENT)
          return JSON.parse(this.templateQuery.CONTENT);
      } else return { Alone: {} };
    },
    taskDetailShow() {
      return this.$store.state.task.type == 1 ? true : false;
    }
  },
  created() {
  },
  methods: {
    getValue(resultList) {
      this.$store.state.resultBase.resultList = [];
      this.clearSelection();
      this.$emit("getValue", resultList, function(str) {
        //传递值，无论是否验证
        // isValidate = str;
      });
    },
    clearSelection() {
      this.$refs.taskTable.clearSelection();
    },
    DetailsEvent(row) {
      this.$refs.taskDetail.openDialog(row);
    },
    operationPanel() {
      //操作结果库面板是否显示
      if (this.expand) {
        this.expand = false;
        this.$store.state.task.isExpand = false;
        this.$store.commit("setIsCheckbox", false);
      } else {
        this.expand = true;
        this.$store.state.task.isExpand = true;
        this.$store.commit("setIsCheckbox", true);
      }
      console.log(this.expand);
    },
    successed() {
      this.curTask = {}
      this.$store.dispatch("changeTaskSource");
      console.log("测试通过");
    },
    changeCurTask(row) {
      console.log("当前选中值", row);
      this.curTask = row;
      if (row) this.taskClass = row.TASKCLASS;
    },
    onViewTypeChange(type) {
      this.viewType = type;
    },
    stateChange(val) {
      console.log("模板值", val);
      let viewType = this.stateData.filter(item => item.value === val);
      if (viewType.length > 0) {
        this.StateName = viewType[0].name;
        if (val == "4") {
          this.taskClass = "shenpi";
        } else {
          this.taskClass = "fuwu";
        }
        this.getAllTask(this.templateQuery, val, 0);
      }
    },
    stateMultipleChange(val) {},
    getExcuteUser(items) {
      let idArr = [];
      // let nameArr = [];
      items.forEach(c => {
        idArr.push(c.ID);
      });
      // items.forEach(c => {
      // 	nameArr.push(c.Name);
      // });
      this.getAllTask(this.templateQuery, idArr.join(","), 1);
      // this.Alone.ExcuteUserName = nameArr.join(",");
    },
    getTeam(items) {
      let OrganizationArr = [];
      let ReceptionArr = [];
      // let nameArr = [];
      items.forEach(c => {
        if (c.Type == 3) {
          ReceptionArr.push(c.SocialId);
        } else {
          OrganizationArr.push(c.SocialId);
        }
      });
      let idArr = {
        Organization: OrganizationArr,
        Reception: ReceptionArr
      };
      this.getAllTask(this.templateQuery, idArr, 2);
      // this.Alone.ExcuteUserName = nameArr.join(",");
    },
    getAllTask(data, val, type) {
      // 点击树结构模板动态查询
      if (data.TEMPTYPE == 0) {
        let content = JSON.parse(data.CONTENT);
        switch (type) {
          case 0: //状态
            if (val == "4") {
              content.TaskClassCode = "shenpi";
              content.state = [val];
            } else {
              content.TaskClassCode = "fuwu";
              content.state = [val];
            }
            break;
          case 1: //执行人
            content.ExcuteUserIds = val;
            break;
          case 2: //团队
            //待完善
            content.TaskRightId = val.Organization.join(",");
            content.ServerCenterIds = val.Reception.join(",");
            break;
          default:
            content.state = [val];
            break;
        }

        // this.$store.state.task.searchCondition = content.queryTitle;
        if (this.category === 7) {
          this.$store.dispatch(
            "GetTaskGroupTaskList",
            searchJs.searchTaskGroup(content, true)
          );
        } else {
          this.$store.dispatch(
            "changeTaskParas",
            searchJs.searchTask(content, true)
          );
        }
      } else if (data.TEMPTYPE == 1) {
        GetTaskListByTaskIdList(data.CONTENT, this.userId).then(res => {
          this.$store.state.task.taskSource = res; // taskList任务列表
        });
      } else if (data.TEMPTYPE == 6) {
      }
    }
  },
  watch: {
    Query(val) {
      if (val) {
        console.log("Query", val);
        this.taskClass = val.Alone.TaskClass;
      }
    }
  },
  mounted() {
    if (this.Query) {
      this.taskClass = this.Query.Alone.TaskClass;
    }
    this.$store.state.task.isExpand = true;
    this.$store.commit("setIsCheckbox", true);
  }
};
</script>

<style lang="scss" scoped>
.suspension { z-index: 500;
  position: fixed;
  bottom: 50%;
  right: 0px;
}
.taskList >>> .el-main {
  padding: 0px;
}
</style>
